 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVERIMAGE from '@/components/CoverImage'
 import WRIGHT_THE_LORD_AND_HIS_PRAYER_TEXT from '@/components/Wright_The_Lord_and_His_Prayer_text'
 import COPYRIGHT from '@/components/Copyright'
 import WRIGHT_THE_LORD_AND_HIS_PRAYER_TEXT1 from '@/components/Wright_The_Lord_and_His_Prayer_text-1'
 import CONTENTS from '@/components/Contents'
 import WRIGHT_THE_LORD_AND_HIS_PRAYER_TEXT2 from '@/components/Wright_The_Lord_and_His_Prayer_text-2'
 import WRIGHT_THE_LORD_AND_HIS_PRAYER_TEXT3 from '@/components/Wright_The_Lord_and_His_Prayer_text-3'
 import WRIGHT_THE_LORD_AND_HIS_PRAYER_TEXT4 from '@/components/Wright_The_Lord_and_His_Prayer_text-4'
 import WRIGHT_THE_LORD_AND_HIS_PRAYER_TEXT5 from '@/components/Wright_The_Lord_and_His_Prayer_text-5'
 import WRIGHT_THE_LORD_AND_HIS_PRAYER_TEXT6 from '@/components/Wright_The_Lord_and_His_Prayer_text-6'
 import WRIGHT_THE_LORD_AND_HIS_PRAYER_TEXT7 from '@/components/Wright_The_Lord_and_His_Prayer_text-7'
 import WRIGHT_THE_LORD_AND_HIS_PRAYER_TEXT8 from '@/components/Wright_The_Lord_and_His_Prayer_text-8'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/CoverImage",
 			"name" : "CoverImage",
 			"component" : COVERIMAGE
 		},
 		{
 			"path" : "/Wright_The_Lord_and_His_Prayer_text",
 			"name" : "Wright_The_Lord_and_His_Prayer_text",
 			"component" : WRIGHT_THE_LORD_AND_HIS_PRAYER_TEXT
 		},
 		{
 			"path" : "/Copyright",
 			"name" : "Copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/Wright_The_Lord_and_His_Prayer_text-1",
 			"name" : "Wright_The_Lord_and_His_Prayer_text-1",
 			"component" : WRIGHT_THE_LORD_AND_HIS_PRAYER_TEXT1
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Wright_The_Lord_and_His_Prayer_text-2",
 			"name" : "Wright_The_Lord_and_His_Prayer_text-2",
 			"component" : WRIGHT_THE_LORD_AND_HIS_PRAYER_TEXT2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js